import React, { useEffect, useState } from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Col, Container, Row } from 'react-bootstrap';
import { FiExternalLink } from 'react-icons/fi';

import FilterByType from './byType';
import Header from './header';
import Footer from './footer';
import Layout from '../../layouts/default';
import SEO from '../../components/seo';
import { formatTime } from '../../components/functions';

import './index.scss';

export default (props) => {
  const allInternal = props.data.allNodeArticle.edges;
  const allExternal = props.data.allNodeArticleExternal.edges;
  const allTypes = props.data.allTaxonomyTermArticleType.edges;

  const [allArticles, setAllArticles] = useState([]);

  const filteredByType = props.pageContext.id
    ? allTypes.filter(
        (edge) => edge.node.id === props.pageContext.id
      )[0].node
    : null;

  useEffect(() => {
    let tmp = [];
    //////////////////////////////////////////////////
    // Collect articles, by type
    // - type: all
    if (filteredByType === null) {
      tmp = [...allInternal, ...allExternal];
    }
    // - type: news, we integrate the external links too
    else if (
      filteredByType.id === 'adf9fe4f-e100-510b-b8f2-cd89204040de'
    ) {
      tmp = [
        ...allExternal,
        ...allInternal.filter((article) => {
          return (
            article.node.relationships.field_type.id ===
            filteredByType.id
          );
        }),
      ];
    }
    // - type: other
    else {
      tmp = [
        ...allInternal.filter((article) => {
          return (
            article.node.relationships.field_type.id ===
            filteredByType.id
          );
        }),
      ];
    }
    tmp.sort((a, b) => b.node.created.localeCompare(a.node.created));
    tmp.sort((a, b) => Number(b.node.sticky) - Number(a.node.sticky));
    setAllArticles([...tmp]);
  }, [filteredByType, allInternal, allExternal]);

  let pageTitle = filteredByType
    ? filteredByType.relationships.field_header.field_heading
    : 'All Articles';
  let pageDescription = filteredByType
    ? filteredByType.relationships.field_header.field_paragraph
    : 'SEE WHAT WE HAVE BEEN UP TO';
  let pageImage = filteredByType
    ? (filteredByType.relationships.field_header.relationships &&
        filteredByType.relationships.field_header.relationships
          .field_background_image.relationships.field_media_image
          .localFile) ||
      props.data.headerImage
    : props.data.headerImage;
  //console.log(props.data.headerImage);
  return (
    <Layout>
      <SEO title={pageTitle} />
      <Header
        title={pageTitle}
        description={pageDescription}
        image={pageImage}
      />
      <section id="ID_article_index">
        <FilterByType location={props.location} />
        <Container>
          <Row>
            {allArticles.map((article, _) => {
              const node = article.node;
              const isExternal =
                node.relationships && node.relationships.field_type
                  ? false
                  : true;
              switch (isExternal) {
                case true: // link type id
                  return (
                    <ExternalArticle key={node.id} article={node} />
                  );
                default:
                  return (
                    <InternalArticle key={node.id} article={node} />
                  );
              }
            })}
          </Row>
        </Container>
      </section>
      {filteredByType && <Footer type={filteredByType} />}
    </Layout>
  );
};

const ExternalArticle = ({ article }) => {
  return (
    <Col xs={12} md={6} xl={3} className={`article-card`}>
      <a
        href={article.field_link.uri}
        target="_blank"
        rel="noreferrer"
      >
        <div className={`article-card__inner`}>
          <Col xs={12} className={`image`}>
            {
              // Background Image
              article.relationships.field_image && (
                <GatsbyImage
                  image={
                    article.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  className={`cover-xy`}
                  imgStyle={{ objectFit: 'cover' }}
                  alt={
                    article.relationships.field_image
                      .field_media_image.alt
                  }
                />
              )
            }
          </Col>
          <Col xs={12} className={`text`}>
            <h6 className={`text-right`}>
              <FiExternalLink
                style={{
                  marginRight: '0.3em',
                  marginTop: '0.6em',
                  marginBottom: '0.6em',
                }}
              />
              Link to {article.field_link.title}
            </h6>
            <h5>{article.title}</h5>
          </Col>
        </div>
      </a>
    </Col>
  );
};

const InternalArticle = ({ article }) => {
  return (
    <Col xs={12} md={6} xl={3} className={`article-card`}>
      <Link to={article.path.alias}>
        <div className={`article-card__inner`}>
          <Col xs={12} className={`image`}>
            {
              // Background Image
              article.relationships.field_image && (
                <GatsbyImage
                  image={
                    article.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  className={`cover-xy`}
                  imgStyle={{ objectFit: 'cover' }}
                  alt={
                    article.relationships.field_image
                      .field_media_image.alt
                  }
                />
              )
            }
          </Col>
          <Col xs={12} className={`text`}>
            <time>{formatTime(article.created)}</time>
            <h6>{article.relationships.field_type.name}</h6>
            <h5>{article.title}</h5>
          </Col>
        </div>
      </Link>
    </Col>
  );
};

export const query = graphql`
  query ($id: String!) {
    headerImage: file(relativePath: { eq: "img_banner_news.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    footerImage: file(relativePath: { eq: "img_banner_news_2.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    allTaxonomyTermArticleType(filter: { id: { eq: $id } }) {
      edges {
        node {
          id
          name
          relationships {
            field_header {
              field_background_color {
                color
                opacity
              }
              relationships {
                field_background_image {
                  field_media_image {
                    alt
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          gatsbyImageData(layout: FULL_WIDTH)
                        }
                      }
                    }
                  }
                }
              }
              field_heading
              field_paragraph
            }
            field_video {
              field_background_color {
                color
                opacity
              }
              relationships {
                field_background_image {
                  field_media_image {
                    alt
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          gatsbyImageData(layout: FULL_WIDTH)
                        }
                      }
                    }
                  }
                }
              }
            }
            field_video {
              relationships {
                field_component_heading {
                  field_heading
                  field_heading_type
                }
                field_video {
                  relationships {
                    field_poster {
                      field_media_image {
                        alt
                      }
                      relationships {
                        field_media_image {
                          localFile {
                            childImageSharp {
                              gatsbyImageData(layout: FULL_WIDTH)
                            }
                          }
                        }
                      }
                    }
                  }
                  field_youtube
                }
              }
            }
            field_call_to_action {
              field_background_color {
                color
                opacity
              }
              relationships {
                field_component_heading {
                  field_heading_type
                  field_heading
                }
                field_component_button_s {
                  relationships {
                    field_button_s {
                      field_link {
                        title
                        uri
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    allNodeArticle(sort: { fields: created, order: DESC }) {
      edges {
        node {
          id
          created
          title
          field_summary
          path {
            alias
          }
          relationships {
            field_type {
              id
              name
            }
            field_image {
              field_media_image {
                alt
              }
              relationships {
                field_media_image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    allNodeArticleExternal(sort: { order: DESC, fields: [created] }) {
      edges {
        node {
          id
          title
          created
          sticky
          field_description
          field_link {
            title
            uri
          }
          relationships {
            field_image {
              field_media_image {
                alt
              }
              relationships {
                field_media_image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
